export const MyAccountScreen = () => {
  return null;
};
